import React, { useState } from "react";
import axios from "axios";

let baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:8000";
let adTenant = process.env.REACT_APP_AD_TENANT;
if (baseURL !== "http://localhost:8000") {
  baseURL += "/api";
}

const LogoutButton: React.FC = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    sessionStorage.clear();

    try {
      const logoutUrl = `${baseURL}/logout`;

      const response = await axios.get(logoutUrl, { withCredentials: true });

      if (response.status === 200) {
        window.location.href = `https://login.microsoftonline.com/${adTenant}/oauth2/v2.0/logout`;
      } else {
        console.error(`Logout request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <button
      className="submit-button logout-button"
      onClick={handleLogout}
      disabled={isLoggingOut}
    >
      Log Out
    </button>
  );
};

export default LogoutButton;
